module.exports = __webpack_public_path__ + "static/img/rank_148.0b819be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_148.png
// module id = Kghd
// module chunks = 0